
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import dynamicSingleField from './dynamic-single-field';
export default {
name: "dynamic-mult-field",
directives: {
TransferDom
},
components: {
Popup,
dynamicSingleField
},
data(){
return{
visible:false,
dataList:[],
inquiryFieldShow:false,
tableItem:[]
}
},
methods:{
initData(field,dynamicData,bol,configData){
if(field){
this.tableItem = field;
this.inquiryFieldShow = false;
if(field.tabsCode === 'inquiry'){
this.$get(`api/person/current`).then((res) => {
this.inquiryFieldShow = res.user.userType !== '0';
});
}
if(dynamicData && dynamicData.data && dynamicData.data[field.tableName]){
this.dataList = JSON.parse(JSON.stringify(dynamicData.data[field.tableName]));
this.dynamicData = dynamicData;
}else{
this.dataList = [];
this.dynamicData = {};
}
this.isEdit = !!bol;
this.visible = true;
}
},
closePop(){

},
changeShow(data){

}
}
}



// WEBPACK FOOTER //
// ./src/page/sources/source-common-module/dynamic-mult-field.vue